import Maybe from 'true-myth/maybe';
import { fromResult } from 'true-myth/toolbelt';

import { getAlignmentRecordPathParamsSchema } from './alignment-record-schema';

import type { AlignmentRecordDetails } from './alignment-record-schema';
import type { FetchAlignmentRecord } from '../../position-management/fetch-alignment-record';
import type { LoaderFunction } from 'react-router';

export type AlignmentRecordPageLoaderData = Maybe<AlignmentRecordDetails>;

export const createAlignmentRecordPageLoader = (fetchAlignmentRecord: FetchAlignmentRecord): LoaderFunction => {
    return async (loaderArguments) => {
        const pathParamsResult = getAlignmentRecordPathParamsSchema.safeParse(loaderArguments.params);

        if (!pathParamsResult.success) {
            return Maybe.nothing();
        }

        const { id, userId } = pathParamsResult.data;

        const alignmentRecordResult = await fetchAlignmentRecord({
            alignmentRecordId: id,
            employeeId: userId,
        });

        return fromResult(alignmentRecordResult);
    };
};
